// Global persistent click handler for all product quick search instances
if (!window.productQuickSearchClickHandlerAttached) {
	window.productQuickSearchClickHandlerAttached = true;
	am.$(document).on('click', function(event) {
		// Capture event target before setTimeout
		var target = event.target;
		
		// Use setTimeout to avoid immediate closure when clicking the button/input
		setTimeout(function() {
			var $target = am.$(target);
			var targetElement = target;
			
			// Check if click is outside ALL search areas (input wrappers and results)
			var isClickInAnySearchArea = false;
			
			// Check all product quick search results instances to see if click is in any of them
			// Use document.querySelectorAll to get all instances, including dynamically added ones
			var allResults = document.querySelectorAll('#product_quick_search_results');
			for (var i = 0; i < allResults.length; i++) {
				var resultsElement = allResults[i];
				
				// Check if click is directly on or within this results dropdown
				if (resultsElement && (resultsElement === targetElement || resultsElement.contains(targetElement))) {
					isClickInAnySearchArea = true;
					break;
				}
				
				// Find the input wrapper for this results element using native DOM traversal
				var inputWrapper = resultsElement ? resultsElement.parentElement : null;
				while (inputWrapper && inputWrapper.id !== 'product_quick_search_input_wrapper') {
					inputWrapper = inputWrapper.parentElement;
					if (!inputWrapper || inputWrapper === document.body || inputWrapper === document.documentElement) {
						inputWrapper = null;
						break;
					}
				}
				
				// Check if target is within this input wrapper
				if (inputWrapper && inputWrapper.contains(targetElement)) {
					isClickInAnySearchArea = true;
					break;
				}
			}
			
			// Also check globally using closest as fallback
			if (!isClickInAnySearchArea) {
				var globalSearchSelector = '#product_quick_search_input_wrapper, #product_quick_search_results, #product_quick_search_query, #product_quick_search';
				if ($target.closest(globalSearchSelector).length > 0) {
					isClickInAnySearchArea = true;
				}
			}
			
			// If click is outside all search areas, close ALL results
			if (!isClickInAnySearchArea) {
				// Use document.querySelectorAll to get all instances, including dynamically added ones
				var allResultsToClose = document.querySelectorAll('#product_quick_search_results');
				for (var j = 0; j < allResultsToClose.length; j++) {
					var $results = am.$(allResultsToClose[j]);
					var display = $results.css('display');
					var opacity = parseFloat($results.css('opacity')) || 1;
					var isVisible = display !== 'none' && opacity > 0;
					
					if (isVisible) {
						// Find the folder - try multiple methods to handle all folder types
						var resultsElement = allResultsToClose[j];
						var folder = null;
						var folder_selector = '';
						
						// Try to find folder by traversing up the DOM
						var current = resultsElement;
						while (current && current !== document.body && current !== document.documentElement) {
							// Check if it's a folder by id starting with "folder_"
							if (current.id && current.id.indexOf('folder_') === 0) {
								folder = current;
								folder_selector = '#' + current.id;
								break;
							}
							// Check if it's a folder by class
							if (current.classList && current.classList.contains('order-folder')) {
								folder = current;
								// Try to get id or data-folder-id
								if (current.id && current.id.indexOf('folder_') === 0) {
									folder_selector = '#' + current.id;
								} else if (current.getAttribute('data-folder-id')) {
									var dataFolderId = current.getAttribute('data-folder-id');
									// Check if there's an element with id="folder_{dataFolderId}"
									var folderById = document.getElementById('folder_' + dataFolderId);
									if (folderById) {
										folder_selector = '#folder_' + dataFolderId;
									} else {
										// Use data-folder-id as selector fallback
										folder_selector = '[data-folder-id="' + dataFolderId + '"]';
									}
								}
								break;
							}
							current = current.parentElement;
						}
						
						// Find and clear the input for this instance
						var $input = null;
						if (folder_selector) {
							$input = am.$(folder_selector + ' #product_quick_search_query');
						}
						if (!$input || $input.length === 0) {
							// Fallback: find input within the same folder element
							if (folder) {
								var inputInFolder = folder.querySelector('#product_quick_search_query');
								if (inputInFolder) {
									$input = am.$(inputInFolder);
								}
							}
						}
						if (!$input || $input.length === 0) {
							// Final fallback: global search
							$input = am.$('#product_quick_search_query');
						}
						
						if ($input.length > 0) {
							$input.val('');
						}
						
						$results.empty();
						$results.fadeOut(150, function() {
							am.$(this).css('display', 'none');
						});
					}
				}
			}
		}, 100);
	});
	
	// Toggle the results panel from the search icon button (moved here from the
	// template partial's inline Prototype onclick)
	am.$(document).on('click', '#product_quick_search_button', function() {
		var $folder_content = am.$(this).closest('.order-folder-content');
		var $results = $folder_content.length ?
			$folder_content.find('#product_quick_search_results').first() :
			am.$('#product_quick_search_results').first();
		$results.toggle();
	});

	// Close all product quick search results when tab becomes hidden (user switches tabs)
	document.addEventListener('visibilitychange', function() {
		if (document.hidden) {
			// Tab is now hidden, close all visible results
			am.$('#product_quick_search_results').each(function() {
				var $results = am.$(this);
				var display = $results.css('display');
				var opacity = parseFloat($results.css('opacity')) || 1;
				var isVisible = display !== 'none' && opacity > 0;
				
				if (isVisible) {
					// Find the folder selector for this instance
					var $folder = $results.closest('[id^="folder_"]');
					var folder_selector = $folder.length > 0 ? '#' + $folder.attr('id') : '';
					
					// Find the input for this instance and clear it
					var $input = folder_selector ? 
						am.$(folder_selector + ' #product_quick_search_query') : 
						am.$('#product_quick_search_query');
					if ($input.length > 0) {
						$input.val('');
					}
					
					$results.empty();
					$results.css('display', 'none');
				}
			});
		}
	});
}

// Content-shaped loading placeholder for the results panel (skeleton doctrine,
// m3/_skeleton.scss; styled in m3/_search.scss). Row shape mirrors a result:
// name line + type line.
function product_quick_search_skeleton_html()
{
	var row = '<div class="pqs-skeleton__row"><div class="am-skeleton-stack">' +
		'<div class="am-skeleton am-skeleton--line am-skeleton--w-60"></div>' +
		'<div class="am-skeleton am-skeleton--line am-skeleton--w-40"></div>' +
		'</div></div>';
	return '<div class="pqs-skeleton">' + row + row + row + '</div>';
}

function product_quick_search_init(folder_id)
{
	var folder_selector = (folder_id ? '#' + folder_id : '');
	if (am.$(folder_selector + ' #product_quick_search_query').length > 0 && am.$(folder_selector + ' #product_quick_search_results').length > 0)
	{
		var $product_quick_search_query = am.$(folder_selector + ' #product_quick_search_query').get(0);
		var $product_quick_search_results = am.$(folder_selector + ' #product_quick_search_results').get(0);

		if (folder_id) {
			$product_quick_search_query.setAttribute('data-folder-id', folder_id);
		}

		// Get local_only from data attribute or form field, default to false
		var local_only = false;
		if ($product_quick_search_query && $product_quick_search_query.getAttribute('data-local-only')) {
			local_only = $product_quick_search_query.getAttribute('data-local-only') === '1' || $product_quick_search_query.getAttribute('data-local-only') === 'true';
		} else if ($('local_only')) {
			local_only = $F('local_only') == '1' || $F('local_only') == 'true';
		}

		var show_results_panel = function(result_element)
		{
			// Use jQuery fadeIn for consistent behavior across browsers and tab switching
			var $resultElement = am.$(result_element);
			$resultElement.css('display', 'block').css('opacity', 0);
			$resultElement.fadeIn(150, function() {
				am.$(this).css('opacity', '');
			});
		};

		var autocompleter = new Ajax.Autocompleter(
			$product_quick_search_query, $product_quick_search_results, 'ajax/',
			{
				parameters: ($('c_form') ? 'table=component_product_quick_search': 'table=product_quick_search' + ($('company_id') ? '&company_id=' + $F('company_id') : '')) + ($('jobs') && $('jobs').getAttribute('data-order_id') ? '&order_id=' + $('jobs').getAttribute('data-order_id') : '') + '&itemized_order=' + ($('itemized_order') ? $F('itemized_order') : 0) + "&local_only=" + (local_only ? "1" : "0"), // !! Temporary disabling of B2B items in itemized orders !!
				minChars: 2,
				frequency: 0.4,
				onShow: function(search_element, result_element)
				{
					show_results_panel(result_element);
				},
				onHide: function(search_element, result_element) {
					// Intentionally inert: panel closing is owned by the persistent
					// click-outside and visibilitychange handlers above.
				},
				afterUpdateElement: product_quick_search_init.callback
			}
		);

		// Skeleton loading state: show content-shaped placeholder rows the moment a
		// fetch starts. Ajax.Autocompleter replaces the panel's innerHTML when the
		// response lands, which swaps the skeleton out naturally.
		var base_get_updated_choices = autocompleter.getUpdatedChoices.bind(autocompleter);
		autocompleter.getUpdatedChoices = function()
		{
			this.entryCount = 0; // no selectable entries while the skeleton is up
			$product_quick_search_results.innerHTML = product_quick_search_skeleton_html();
			if (am.$($product_quick_search_results).css('display') === 'none') {
				show_results_panel($product_quick_search_results);
			}
			base_get_updated_choices();
		};

		am.$(document).on('click', folder_selector + ' #product_quick_search_query', function ()
		{
			// If user leaves and returns to search input, and wants to search for exact same text, ENTER key is ignored because
			// search input is not contained in its own wee form (because its already enclosed by another form, and forms within
			// forms are invalid markup).  If this solution (to force user to retype search criteria) is disliked, the alternative
			// is to hack protoaculous.js so that Autocompleter's onKeyPress doesn't ignore the ENTER key.
			// am.$(folder_selector + ' #product_quick_search_query').toggle();
			am.$(folder_selector + ' #product_quick_search_query').val('');
			// Clear the results container (ul and li elements)
			am.$(folder_selector + ' #product_quick_search_results').empty();
		});
	}
}


product_quick_search_init.callback = function(textInput, li)
{
	// type is expected to be Component, Product, or Supply
	var type = li.getAttribute('data-type');
	if (!type) return; // the "No results found" row is not selectable
	var folder_id = textInput.getAttribute('data-folder-id');
	get_form(type.toLowerCase(), li, li.getAttribute('data-id'), li.getAttribute('data-catalog_b'), folder_id);
	// reset the field and close this instance's panel once a pick is made (legacy left
	// both populated and relied on the category selector re-render to clean them up)
	textInput.value = '';
	am.$(textInput).closest('#product_quick_search_input_wrapper')
		.find('#product_quick_search_results').fadeOut(150, function() {
			am.$(this).empty();
		});
};
